import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const useTranslation = () => {
  const intl = useIntl();
  const t = useCallback(
    (key: string, values?: Record<string, any>) => {
      return intl.formatMessage({ id: key }, values);
    },
    [intl],
  );

  return t;
};
